import React from 'react'
import { getMessage } from '../../../../../../../lib/translator'
import PoaOrderGroupCard from './PoaOrderGroupCard'
import './style.scss'

/**
 * Items the customer added after placing this order. DSP fulfils them on a separate
 * delivery order, so this surfaces the linked order's packlists below the page's own
 * (LIT-541). Only the linked orders are listed — this order's items are already in the
 * table above.
 */
const PoaGroupedPacklists = ({
  groups = [],
  currency,
  orderStatus,
  loading = false,
  basePath = '/operations/picking-delivery-orders',
}) => {
  const otherGroups = groups.filter((group) => !group.isOwn)
  const hasItems = otherGroups.some((group) => group.itemCount > 0)

  if (loading || groups.length < 2 || !hasItems) {
    return null
  }

  return (
    <section
      className="dsp-order-detail__poa"
      aria-labelledby="dsp-poa-heading"
      data-testid="dsp-poa-section"
    >
      <div className="dsp-order-detail__poa-divider" />

      <div className="dsp-order-detail__poa-header">
        <h2 id="dsp-poa-heading" className="dsp-order-detail__poa-title">
          {getMessage('picking.orderDetail.poa.section.title')}
        </h2>
        <span
          className="dsp-order-detail__poa-count-pill"
          data-testid="dsp-poa-count"
        >
          {getMessage('picking.orderDetail.poa.section.count', {
            orders: groups.length,
          })}
        </span>
      </div>

      {otherGroups.map((group) => (
        <PoaOrderGroupCard
          key={group.deliveryOrderNo || group.packlists[0]?.id}
          group={group}
          currency={currency}
          orderStatus={orderStatus}
          basePath={basePath}
        />
      ))}
    </section>
  )
}

export default PoaGroupedPacklists
